import { Spinner } from 'construct-ui';
import Sortable from 'sortablejs';
import { v4 as uuidv4 } from 'uuid';
import { messageComponent } from '../../../../components/message/message.component';
import ViewBase from '../../../view-base.view';

export default function TaskMasterRadioListView() {

    ViewBase.call(this);
    let inputDatModel = { radioList: [] };
    let isLoading = false;
    let isMsgOpen = false;
    let showMsg = "";
    let msgTitle = "";
    let controlerId = "";

    let _onChanged = (e) => { }

    let _dialogClosed = () => {
        isMsgOpen = false;
    }

    let _removeItem = (item) => {
        inputDatModel.radioList = inputDatModel.radioList.filter(x => x.id != item.id);
    }

    return {
        oninit: function (vnode) {
            if (vnode.attrs.onChanged) {
                _onChanged = vnode.attrs.onChanged;
            }

            if (vnode.attrs.radioList) {
                inputDatModel.radioList = vnode.attrs.radioList;
            }
            if (vnode.attrs.id) {
                controlerId = vnode.attrs.id;
            }
        },
        oncreate: function (vnode) {
            if (vnode.attrs.canEdit) {
                const radioList = document.getElementById(controlerId);
                new Sortable(radioList, {
                    animation: 150,
                    ghostClass: 'sortable-ghost',
                    dragClass: 'sortable-drag',
                    handle: '.drag-grip',
                });
            }
        },
        onupdate: function (vnode) {
            if (vnode.attrs.canEdit) {
                const radioList = document.getElementById(controlerId);
                new Sortable(radioList, {
                    animation: 150,
                    ghostClass: 'sortable-ghost',
                    dragClass: 'sortable-drag',
                    handle: '.drag-grip',
                });
            }
        },
        view: (vnode) => {
            return [
                m(Spinner, {
                    active: isLoading,
                    background: true,
                    fill: true,
                    size: 'xl',
                }),
                m('.card',
                    m('.card-body',
                        m('.col-md-12.radio-list-height',
                            m('.col-md-12.row',
                                m('ul[id="' + controlerId + '"].moveable',
                                    inputDatModel.radioList.map(dtVal => [
                                        m('li.drag-grip', { 'data-id': dtVal.id },
                                            m('.row.mb-2',
                                                m('.col-sm-8',
                                                    m("input[type='text']", {
                                                        "class": "form-control form-control-bg",
                                                        value: dtVal.name,
                                                        disabled: !vnode.attrs.canEdit,
                                                        onkeyup: e => {
                                                            dtVal.name = e.target.value;
                                                        }
                                                    }),
                                                    m('input[type="hidden"][value="' + dtVal.taskListItemID + '"]')
                                                ),
                                                vnode.attrs.canEdit &&
                                                m('.col-md-1', m('.remove_field.mt-1',
                                                    {
                                                        onclick: e => {
                                                            _removeItem(dtVal);
                                                        }
                                                    },
                                                    m('span', m('i.bi.bi-dash-circle.me-0')))
                                                )
                                            )
                                        )
                                    ])
                                )
                            )
                        ),
                        vnode.attrs.canEdit && m('.col-md-12', m('hr'), m('.col-md-3', m('button.btn.btn-primary', {
                            onclick: () => {
                                inputDatModel.radioList.push({ name: "", id: uuidv4(), taskListItemID: "0" });
                            }
                        }, this.getText("LT00000090", "Add"))))
                    )
                ),
                m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: _dialogClosed }),
                this.getBaseViews()
            ]
        }
    }
}
